import loadable from '@loadable/component';
import storePageQuery from './query.graphql';

const StorePage = loadable(() =>
  import(/* webpackChunkName: "store" */ './store')
);

StorePage.graphQL = storePageQuery;

StorePage.variables = ({ id, offset }) => ({
  id,
  offset: parseInt(offset, 10) || 0,
});

StorePage.loadOrder = [{}];

export default StorePage;
